<template>
  <div
    id="home"
    class="header-container"
  >
    <div class="page-header-part">
      <div class="bonuscloud-header">
        <div
          class="page-logo"
          style="position:relative"
        >
          <a
            class="logo"
            href="/"
          ></a>
          <a
            class="login"
            target="_blank"
            :href="consoleHost + '/login'"
          >{{ $t('LOGIN') }}</a>
          <div
            style="
              display: inline-block;
              height: 14px;
              width: 1px;
              background: #fff;
              position: absolute;
              right: 68px;
              top: 10px;"
              class="login_line"
          ></div>
          <a
            class="signup"
            target="_blank"
            :href="consoleHost + '/signUp'"
          >{{ $t('SIGNUP') }}</a>
        </div>
        <div class="page-nav-container">
          <div class="page-nav-content">  
            <a
              href="javascript:void(0)"
              class="mobile-nav-icon"
              @click="showNav"
            ></a>
            <ul
              class="nav-list"
              v-if="navStatus"
              
            >
              <li class="nav-login">
                <a
                  class="nav-item"
                  :href="consoleHost + '/login'"
                >{{$t('LOGIN')}}</a>
              </li>
              <li class="nav-login">
                <a
                  class="nav-item"
                  :href="consoleHost + '/signUp'"
                >{{ $t('SIGNUP') }}</a>
              </li>
              <li>
                <a
                  class="nav-item"
                  anchor="home"
                  href="#"
                >{{ $t('HOME') }}</a>
              </li>
              <li>
                <a
                  class="nav-item"
                  anchor="highlight"
                  href="#highlight"
                >{{ $t('HIGHLIGHT') }}</a>
              </li>
              <li>
                <a
                  class="nav-item"
                  anchor="advantage"
                  href="#advantage"
                >{{ $t('ADVANTAGE') }}</a>
              </li>
              <!-- <li>
                <a
                  class="nav-item"
                  anchor="team"
                  href="#team"
                >{{ $t('MEMBER') }}</a>
              </li> -->
              <!-- <li> -->
                <!-- <a class="nav-item" anchor="agency" href="#agency">AGENCY</a>
                <a
                  class="nav-item"
                  anchor="agency"
                  href="#agency"
                >{{ $t('PARTNER') }}</a>
              </li> -->
              <!-- <li>
                <a
                  class="nav-item"
                  anchor="token"
                  href="#token"
                >{{ $t('TOKEN') }}</a>
              </li> -->
              <!-- <li>
                <a
                  class="nav-item"
                  anchor="exchange"
                  href="#exchange"
                >{{ $t('Exchange') }}</a>
              </li> -->
              <li>
                <a
                  class="nav-item"
                  anchor="community"
                  href="#community"
                >{{ $t('COMMUNITY') }}</a>
              </li>
              <!-- <li>
                <a
                  class="nav-item"
                  anchor="faq"
                  href="#faq"
                >{{ $t('FAQ') }}</a>
              </li> -->
              <!-- <li>
                <a
                  class="nav-item"
                  anchor="roadmap"
                  href="#roadmap"
                >{{ $t('ROADMAP') }}</a>
              </li> -->
              <!-- <li>
                <a
                  @click="changeLanguage"
                  class="nav-item menu-language"
                >{{ $t('LANGUAGE') }}</a>
              </li> -->
            </ul>
          </div>
          <!-- 联系方式 -->
          <div class="contact_container">
            <ul>
              <li @mouseover="showQRCode" @mouseout="unshowQRCode"><img src="../../assets/contact/contact_QQ.png" alt=""></li>
              <li @mouseover="showQRCode1" @mouseout="unshowQRCode1"><img src="../../assets/contact/contact_WECHAT.png" alt=""></li>
              <li @click="scrollTop"><img src="../../assets/contact/contact_ARROW.png" alt=""></li>
            </ul>
          </div>
          <div class="contact_qrcode" v-if="showQQCode">
            <img src="../../assets/qqqrcode.png" alt="">
            <p style="color: black;">QQ扫码入群</p>
          </div>
          <div class="wechatCode" v-if="showWeChatCode">
            <img src="../../assets/wxqrcode_xiaoxi.png" alt="">
            <img src="../../assets/wxqrcode_dahai.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<i18n>
{
  "en": {
    "LOGIN": "LOGIN",
    "SIGNUP": "SIGN UP",
    "HOME": "HOME",
    "HIGHLIGHT": "HIGHLIGHT",
    "ADVANTAGE": "ADVANTAGE",
    "ROADMAP": "ROADMAP",
    "COMMUNITY": "COMMUNITY",
    "MEMBER": "MEMBER",
    "TOKEN": "TOKEN",
    "PARTNER": "PARTNER",
    "LANGUAGE": "CHINESE",
    "Exchange": "EXCHANGE"
  },
  "zn": {
    "LOGIN": "登录",
    "SIGNUP": "注册",
    "HIGHLIGHT": "亮点",
    "HOME": "首页",
    "ADVANTAGE": "核心优势",
    "ROADMAP": "路线图",
    "COMMUNITY": "社区",
    "MEMBER": "团队成员",
    "TOKEN": "TOKEN",
    "PARTNER": "合作伙伴",
    "LANGUAGE": "英文",
    "Exchange": "交易所"
  }
}
</i18n>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "PcLogin",
  props: {},
  data() {
    return {
      navStatus: true,
      showQQCode: false,
      showWeChatCode:false,
    };
  },
  computed: mapState({
    isZnWebsite: state => state.isZnWebsite,
    consoleHost: state => {
      if (state && state.isZnWebsite) {
        return 'https://console.bonuscloud.work';
      } else {
        return 'https://console.bonuscloud.io';
      }
    }
  }),
  methods: {
    ...mapActions([]),
    showNav() {
      this.navStatus = !this.navStatus;
    },
    scrollTop(){
      scrollTo(0,0);
    },
    showQRCode(){
      this.showQQCode = true;
    },
    unshowQRCode(){
      this.showQQCode = false;
    },
    showQRCode1(){
      this.showWeChatCode = true;
    },
    unshowQRCode1(){
      this.showWeChatCode = false;
    }
    // changeLanguage() {
    //   let locale = this.$cookie.get('BASIC_LANUAGE') || 'en';
      
    //   let whichLanguage;
    //   if (locale === 'en') {
    //     whichLanguage = 'zn';
    //   } else {
    //     whichLanguage = 'en';
    //   }
    //   this.$i18n.locale = whichLanguage;
    //   this.$cookie.set('BASIC_LANUAGE', whichLanguage);
    //   window.location.reload();

    // },
    // changeLanguage(locale) {
    //   this.whichLanguage = locale === "zn";
    //   this.$i18n.locale = locale;
    //   this.$cookie.set("BASIC_LANUAGE", locale);
    //   window.location.reload();
    // },
  },
  created() {
    // let language = this.$cookie.get('BASIC_LANUAGE');
    // this.$i18n.locale = language;
    this.$i18n.locale = this.isZnWebsite ? "zn" : "en";
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
.page-header-part {
    .page-logo {
        display: none;
    }
    .nav-login {
        display: none
    }
    .page-logo .logo {
        display: inline-block;
        width: 180px;
        height: 30px;
        background: url(../../assets/common/logo.png) no-repeat;
        background-size: contain;
        /*background-position:0 7px;*/
    }
    .login{
        position: absolute;
        right: 70px;
        color: #fff;
        line-height: 35px;
        display: inline-block;
        width: 60px;
    }
    .signup{
        position: absolute;
        right: 0px;
        color: #fff;
        line-height: 35px;
    }
    .page-nav-container {
        position: fixed;
        z-index: 20;
        top: 35%;
        right: 35px;
        display: inline-block;
        height: 350px;
        .page-nav-content {
            margin-top: -40%;
        }
        
        // 固定定位 联系 
        .contact_container{
          position: fixed;
          right: 35px;
          // top: 450px;
          top 64%
          width: 45px;
          border: 2px solid #0db4c5;
          border-top: 6px solid #0db4c5; 
          background-color: #000519;
          li{
            width:82%;
            height:50px;
            border-bottom:1px solid #5A5E6A;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 auto;
            cursor pointer
            img{
              width 80%
            }
          }
          li:hover{
            border-bottom:1px solid #0db4c5;
          }
          li:nth-child(3){
            border-bottom none
          }
        }
        .contact_qrcode{
          position: fixed;
          top: 64%; 
          right: 95px;
          width: 140px
          height 160px
          background-color: #EFEFED;
          border: 1px solid #0db4c5;
          box-shadow: 0px 0px 10px 2px #0db4c5;
          text-align center
          padding-top 10px
          img{
            width 90%
          }
        }
        .wechatCode{
          width 265px
          height 138px
          position: fixed;
          top: 71%;
          right: 95px;
          background-color: white;
          border: 1px solid #0db4c5;
          box-shadow: 0px 0px 10px 2px #0db4c5;
          display: flex;
          justify-content: space-around; 
          align-items: center;
          img{
            width 110px
          }
        }
        
        
        .nav-list li {
            text-align: right;
        }
        .nav-item {
            display: inline-block;
            padding: 12px 0px 12px 30px;
            font-size: 12px;
            color: rgba(255,255,255,.5);
            text-decoration: none;
            letter-spacing: 5px;
            &::after {
                margin-left: 30px;
                display: inline-block;
                content: '';
                width: 11px;
                height: 11px;
                background: url(../../assets/pageheader/nav-icon.png) no-repeat;
                background-size: contain;
            }
            &:hover {
                font-weight: bold;
                &::after {
                    background-image: url(../../assets/pageheader/nav-icon-hover.png);
                }
            }
            &.active {
                color: #fff;
                font-weight: bold;
                &::after {
                    background-image: url(../../assets/pageheader/nav-icon-active.png);
                }
            }
        }
    }
    .menu-language {
      display: none !important;
    }
}

@media (max-width: 720px) {
   
   .contact_container{
      display none
   }
   
    .header-container {
        position: fixed;
        z-index: 1001;
        top: 0;
        width: 100%;
        box-sizing: border-box;
        padding: 20px 5%;
        background-color: #000;
    }
    .nav-login {
        display: block !important;
    }
    .login{
        display: none!important;
        // right: 60px!important;
        // top: 5px;
    }
    .login_line{
        display: none!important;
    }
    .signup{
    //     right: 60px!important;
        display: none
    }
    .page-header-part {
        position: relative;
        &, .bonuscloud-header {
            height: 27px;
        }
        .page-logo {
            display: block;
        }
        .page-logo .logo {
            width: 160px;
            height: 27px;
        }
        .page-nav-container {
            position: absolute;
            right: 0;
            top: 0;
            .menu-language {
              display: block !important;
            }
            .page-nav-content {
                margin-top: 0;
            }
            .mobile-nav-icon {
                display: inline-block;
                width: 27px;
                height: 27px;
                background: url(../../assets/pageheader/m-nav-icon.png) no-repeat;
                background-size: contain;
                background-position: bottom;
            }
            .nav-list {
                display: none;
                width: 100%;
                position: fixed;
                right: 0;
                background-color: #000;
                padding: 20px 0;
                li {
                    text-align: center;
                }
                .nav-item {
                    display: block;
                    padding: 15px 30px;
                    &::after {
                        display: none;
                    }
                }
            }
        }
    }
}

</style>
